import { useMutation } from '@apollo/react-hooks'
import { gql } from 'apollo-boost'

const ENABLE_DEVICE_ACKS_MUTATION = gql`
  mutation EnableDeviceAcks($device: String!) {
    enableDeviceAcks(input: { device: $device }) {
      acksEnabled
    }
  }
`

const DISABLE_DEVICE_ACKS_MUTATION = gql`
  mutation DisableDeviceAcks($device: String!) {
    disableDeviceAcks(input: { device: $device }) {
      acksEnabled
    }
  }
`

interface EnableDeviceAcksData {
  enableDeviceAcks: { acksEnabled: boolean }
}

interface EnableDeviceAcksVariables {
  device: string
}

interface DisableDeviceAcksData {
  disableDeviceAcks: { acksEnabled: boolean }
}

interface DisableDeviceAcksVariables {
  device: string
}

export const useEnableDeviceAcks = () =>
  useMutation<EnableDeviceAcksData, EnableDeviceAcksVariables>(ENABLE_DEVICE_ACKS_MUTATION)

export const useDisableDeviceAcks = () =>
  useMutation<DisableDeviceAcksData, DisableDeviceAcksVariables>(DISABLE_DEVICE_ACKS_MUTATION)
